import React from 'react';
import Fade from '@material-ui/core/Fade';
import LoadingView from 'components/LoadingView';

const PersistLoading = () => (
  <Fade in timeout={3000}>
    <LoadingView
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
      title="Loading local data..."/>
  </Fade>
);
export default PersistLoading;
